/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { RouteProtection } from '@/data/containers/manifest';
import { TranslationTable } from 'integration/generated/translations';
import { Layout } from '@/data/types/Layout';
import { User } from '@/data/User';
import { getBrandCategoryLayoutContainer } from './aurora/BrandCategoryLayoutContainer';
import { IncomingContent } from '@/data/types/IncomingContent';
import { getIntertoysHomePageContainer1 } from './aurora/IntertoysHomePageContainer1';
import { getIntertoysActiePageContainer } from './aurora/IntertoysActiePageContainer';
import { getIntertoysHomePageContainer_rv } from './IntertoysHomePageContainer_rv';
import { getIntertoysActiesAndFolderContainer1_rv } from './IntertoysActiesAndFolderContainer1_rv';
import { getIntertoysActiesAndFolderContainer2_rv } from './IntertoysActiesAndFolderContainer2_rv'; 
import { getIntertoysActiesAndFolderContainer3_rv } from './IntertoysActiesAndFolderContainer3_rv';
import { getIntertoysCustomerServiceContainer_rv } from './IntertoysCustomerServiceContainer_rv';
import { getIntertoysCategoryBrandPageContainer_rv } from './IntertoysCategoryBrandPageContainer_rv';
import { getIntertoysListingPageContainer_rv } from './IntertoysListingPageContainer_rv';
import { getIntertoysProductPageContainer_rv } from './IntertoysProductPageContainer_rv';
import { getDepartmentPageContainer } from './aurora/DepartmentPageContainer';
import { getStoreLocatorStreetPageContainer } from './StoreLocatorStreetPageContainer';
import { getStoreLocatorCityPageContainer } from './StoreLocatorCityPageContainer';
import { getPunchoutPaymentRedirectContainer } from './PunchoutPaymentRedirect';
import { getPaymentPunchoutCallbackPage } from './PaymentPunchoutCallback';
import { validateProtectedRoute } from '@/data/utils/validateProtectedRoute';
import { getReturnOrderPage } from './ReturnOrderPage';
import { getFavouriteStorePage } from './FavouriteStorePage';
import { getPersonalInfoPage } from './PersonalInfoPage';
import { getMyAddressBookPage } from './MyAddressBookPage';
import { getForgetMePage } from './ForgetMePage';
import { getUserActivationCallbackPage } from './UserActivationCallback';
import { getContentPageContainer } from './aurora/ContentPageContainer';
import { getSearchResultPageContainer } from './aurora/SearchResultPageContainer';
import { getSearchLandingPageContainer } from './aurora/SearchLandingPageContainer';
import { getSubCategoryPageContainer } from './aurora/SubCategoryPageContainer';
import { getProductListingPageAurora } from './ProductListingPageAurora';
import { getNewsLetterSubscriptionPage } from './NewsLetterSubscription';
import { getIntertoysNewsLetterSubscriptionSubmitPage } from './IntertoysNewsLetterSubscriptionSubmit';
import { getReturnOrderGuestPage } from './ReturnOrderGuestPage';
import { getStoreStockPage } from './StoreStockPage'; 
import { getCancelOrderOmsPage } from './CancelOrderOmsPage';
import { getSharedWishListView } from './SharedWishListView';
import { getResendActivationEmail } from './ResendActivationEmail';
import { MyOrdersPage } from './MyOrdersPage';
import { getIntertoysListingPage4slotContainer_rv } from './IntertoysListingPage4slotContainer_rv';
import { getRevokeOrderPage } from './RevokeOrderPage';
import { getRevokeOrderGuestPage } from './RevokeOrderGuestPage';

const layoutManifest = {
	BrandCategoryLayoutContainer : getBrandCategoryLayoutContainer,
	IntertoysHomePageContainer1 : getIntertoysHomePageContainer1,
	IntertoysHomePageContainer1Responsive : getIntertoysHomePageContainer1,
	IntertoysActiePageContainer : getIntertoysActiePageContainer,
	DepartmentPageContainer: getDepartmentPageContainer,
	ContentPageContainer: getContentPageContainer,
	SearchResultPageContainer:getSearchResultPageContainer,
	SearchLandingPageContainer:getSearchLandingPageContainer,
	SubCategoryPageContainer:getSubCategoryPageContainer,
	IntertoysHomePageContainerRv : getIntertoysHomePageContainer_rv,
	IntertoysActiesAndFolderContainer1Rv : getIntertoysActiesAndFolderContainer1_rv,
	IntertoysActiesAndFolderContainer2Rv : getIntertoysActiesAndFolderContainer2_rv,
	IntertoysActiesAndFolderContainer3Rv : getIntertoysActiesAndFolderContainer3_rv, 
	IntertoysCustomerServiceContainerRv : getIntertoysCustomerServiceContainer_rv,
	IntertoysCategoryBrandPageContainerRv : getIntertoysCategoryBrandPageContainer_rv,
	IntertoysListingPageContainerRv : getIntertoysListingPageContainer_rv,
	IntertoysListingPage4SlotContainerRv : getIntertoysListingPage4slotContainer_rv,
	IntertoysProductPageContainerRv: getIntertoysProductPageContainer_rv,
	StoreLocatorCityPage: getStoreLocatorCityPageContainer,
	StoreLocatorStreetPage: getStoreLocatorStreetPageContainer,
	PunchoutPaymentRedirect:getPunchoutPaymentRedirectContainer,
	PunchoutPaymentCallBack:getPaymentPunchoutCallbackPage,
	ReturnOrderPage: getReturnOrderPage,
	ReturnOrderGuestPage:getReturnOrderGuestPage,
	FavouriteStorePage: getFavouriteStorePage,
	PersonalInfoPage: getPersonalInfoPage,
	MyAddressBookPage: getMyAddressBookPage,
	ForgetMePage: getForgetMePage,
	UserActivationCallBack: getUserActivationCallbackPage,
	ProductListingPageAurora: getProductListingPageAurora,
	NewsLetterSubscription: getNewsLetterSubscriptionPage,
	IntertoysNewsLetterSubscriptionSubmit: getIntertoysNewsLetterSubscriptionSubmitPage,
	StoreStockPage: getStoreStockPage,
	CancelOrderOmsPage: getCancelOrderOmsPage, 
	SharedWishListView: getSharedWishListView,
	ResendActivationEmail: getResendActivationEmail,
	MyOrders: MyOrdersPage,
	RevokeOrderPage:getRevokeOrderPage,
	RevokeOrderGuestPage:getRevokeOrderGuestPage
};

export const dataContainerManifestCustom: {
	[key: string]: (cLayout: IncomingContent) => Layout;
} = layoutManifest;

type LayoutKeys = keyof typeof layoutManifest;
type LocalRoutes = TranslationTable['Routes'];

/**
 * Layout relationships with translation route name as the key and
 * the layoutManifest key as the value.
 */
export const dataRouteManifestCustom: Record<string, LayoutKeys> = {

	StoreLocatorCity: 'StoreLocatorCityPage',
	StoreLocatorStreet: 'StoreLocatorStreetPage',
	PunchoutPaymentCallBack:'PunchoutPaymentCallBack',
	PunchoutPaymentRedirect:'PunchoutPaymentRedirect',
	ReturnOrder: 'ReturnOrderPage',
	ReturnOrderGuest: 'ReturnOrderGuestPage',
	FavouriteStore: 'FavouriteStorePage',
	PersonalInfo: 'PersonalInfoPage',
	MyAddressBook: 'MyAddressBookPage',
	ForgetMe: 'ForgetMePage',
	UserActivationCallBack: 'UserActivationCallBack',
	NewsLetterSubscription: 'NewsLetterSubscription',
	IntertoysNewsLetterSubscriptionSubmit: 'IntertoysNewsLetterSubscriptionSubmit',
	StoreStock:'StoreStockPage',
	CancelOrderOmsPage: 'CancelOrderOmsPage',
	SharedWishListView: 'SharedWishListView',
	ResendActivationEmail: 'ResendActivationEmail',
	MyOrders: 'MyOrders',
	RevokeOrder: 'RevokeOrderPage',
	RevokeOrderGuest: 'RevokeOrderGuestPage'
};


/**
 * Map of routes that are dependent on the user status for conditional
 * redirection or other protection. The method return dictates the
 * behavior:
 * 	- true: allow access
 * 	- false: do not load the route
 * 	- string: redirect to the route named in the string
 */
export const dataRouteProtectionCustom: Partial<
	Record<keyof LocalRoutes, (user: Partial<User>) => RouteProtection>
> = {
	ReturnOrder: (user) => validateProtectedRoute({ user }, 'login'),
	FavouriteStore: (user) => validateProtectedRoute({ user }, 'login'),
	PersonalInfo: (user) => validateProtectedRoute({ user }, 'login'),
	MyAddressBook: (user) => validateProtectedRoute({ user }, 'login'),
	ForgetMe: (user) => validateProtectedRoute({ user }, 'login'),
	MyOrders: (user) => validateProtectedRoute({ user }, 'login'),
	RevokeOrder: (user) => validateProtectedRoute({ user }, 'login'),
};

export const dataRouteProtectionFlexFlowMapCustom: Partial<Record<keyof LocalRoutes, string>> = {};

export const notCDNCacheableRouteCustom: Partial<Record<keyof LocalRoutes, boolean>> = {};
